"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useManager = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var useManager = function () {
    var isAuth = (0, user_1.useIsAuthorized)();
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.GET_MANAGER,
        canRender: isAuth,
        revalidateOnMount: true,
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error;
    return {
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
    };
};
exports.useManager = useManager;
